import { reviewFact, reviewText, statusFromRuntime } from '../../runtime/review-contribution-helpers'
import { RequestHandlingStrategy } from './request-handling-strategy'

const strategyText = strategy => {
    if (strategy === RequestHandlingStrategy.ANSWER_REQUEST_DIRECTLY) {
        return reviewText(
            'Page(ReceivedRequest):Component(RequestHandling):answer-myself-title',
            'I will answer the request myself',
        )
    }

    if (strategy === RequestHandlingStrategy.FORWARD_TO_PRODUCT_SUPPLIER) {
        return reviewText(
            'Page(ReceivedRequest):Component(RequestHandling):product-supplier-title',
            'Send the complete request to the product supplier',
        )
    }

    if (strategy === RequestHandlingStrategy.COLLECT_FROM_COMPONENT_SUPPLIERS) {
        return reviewText(
            'Page(ReceivedRequest):Component(RequestHandling):component-suppliers-title',
            'Collect information from component suppliers',
        )
    }

    return reviewText(
        'Page(ReceivedRequest):Component(WorkflowReview):not-selected',
        'Not selected',
    )
}

const createRequestHandlingReviewContribution = ({ context, step }) => {
    const workflowState = context.requestHandling && context.requestHandling.workflowState
        ? context.requestHandling.workflowState
        : {}
    const hierarchy = context.productHierarchy || {}
    const componentCount = Array.isArray(hierarchy.children) ? hierarchy.children.length : 0
    const strategy = strategyText(workflowState.strategy)

    return {
        status: statusFromRuntime(step),
        summary: strategy,
        facts: [
            reviewFact(
                'strategy',
                reviewText(
                    'Page(ReceivedRequest):Component(WorkflowReview):handling-strategy',
                    'Handling strategy',
                ),
                strategy,
            ),
            ...(workflowState.strategy === RequestHandlingStrategy.COLLECT_FROM_COMPONENT_SUPPLIERS
                ? [reviewFact(
                    'components',
                    reviewText(
                        'Page(ReceivedRequest):Component(WorkflowReview):components',
                        'Components',
                    ),
                    componentCount,
                )]
                : []),
        ],
        checks: [],
    }
}

export { createRequestHandlingReviewContribution }
export default createRequestHandlingReviewContribution
